module.exports = __webpack_public_path__ + "static/media/prick_HMPG_header_image_01_1000.854f34da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_header_image_01_1000.jpg
// module id = 343
// module chunks = 0